module.exports = "/assets/site/images/hamar_edina_portfolio.jpg?35e440f96fb309f693558b6e8dacad8f";